module.exports = __webpack_public_path__ + "img/alentour23.28dbf212.jpg";